import EOrderingLogo from "@assets/images/eOrdering.png";
import warningIcon from "@assets/images/exclamation.svg";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import { Button, Paper } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/styles";
import HeadColored from "@saleor/components/HeadColored";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React, { FC } from "react";

const useStyle = makeStyles(
  theme => ({
    root: {
      height: "100%",
      marginBottom: "200px"
    },
    duplicate_mainPanel: {
      background: "transparent"
    },
    duplicate_headTextLogo: {
      margin: "120px 0 104px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    duplicate_text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17"
    },
    duplicate_logo: {
      marginLeft: 20
    },
    duplicate_paper: {
      width: "420px",
      padding: "43px 32px 32px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    duplicate_caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.6rem"
    },
    duplicate_warningIcon: {
      width: 56,
      height: 56,
      marginBottom: "2.7rem"
    },
    duplicate_errorcode: {
      color: theme.palette.grey[500],
      marginBottom: "1.6rem"
    },
    duplicate_btnSubmit: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",

      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    }
  }),
  { name: "DuplicateOrderError" }
);

interface DuplicateOrderErrorProps {
  errorCode?: string;
  onFailed: () => void;
  styles?: ClassNameMap<"container" | "root" | "footer">;
}

const DuplicateOrderError: FC<DuplicateOrderErrorProps> = ({
  errorCode,
  onFailed,
  styles
}) => {
  const classes = useStyle();

  return (
    <>
      <HeadColored fixedTop />
      <div className={styles.container}>
        <div className={classes.root}>
          <div className={classes.duplicate_mainPanel}>
            <div className={classes.duplicate_headTextLogo}>
              <div className={classes.duplicate_text}>
                <img src={SCGP_Color} alt={"logo_scg"} />
              </div>
              <div className={classes.duplicate_logo}>
                <img src={EOrderingLogo} alt={"logo"} />
              </div>
            </div>
            <Paper className={classes.duplicate_paper}>
              <img
                src={warningIcon}
                alt=""
                className={classes.duplicate_warningIcon}
              />
              <MyTypography variant="h6" className={classes.duplicate_caption}>
                ไม่สามารถทำรายการได้
              </MyTypography>
              <MyTypography
                variant="body3"
                className={classes.duplicate_errorcode}
              >
                Error code: {errorCode}
              </MyTypography>
              <Button
                onClick={onFailed}
                className={classes.duplicate_btnSubmit}
              >
                <MyTypography variant="body1">ปิดหน้าต่าง</MyTypography>
              </Button>
            </Paper>
          </div>
        </div>
        <footer className={styles.footer}>
          <MyTypography variant="body3" style={{ color: "#333333" }}>
            COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
          </MyTypography>
        </footer>
      </div>
    </>
  );
};

export default DuplicateOrderError;
